import { Link } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useListAbundanceEngineViews } from '../../../../../api/abundanceEngine'
import SydButton from '../../../../commonDesign/Button'
import SydInput from '../../../../commonDesign/SydInput'
import OpalGrid, { useGridPageState, useGridSortState } from '../../../../organisms/DenaliAnalysis/tables/operational'
import { columnConfig } from './columnConfig'
import ViewTagsAutocomplete from './ViewTagsAutocomplete'

function AbundanceEngineListView () {
  const { pageState, setPageState } = useGridPageState(20)
  const { sortState, setSortState } = useGridSortState(columnConfig.defaultSort)

  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [tags, setTags] = useState([])

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
      if (searchTerm !== debouncedSearchTerm) {
        setPageState(prev => ({ ...prev, pageIndex: 0 }))
      }
    }, 500)

    return () => clearTimeout(timer)
  }, [searchTerm, debouncedSearchTerm, setPageState])

  const { data = [], isLoading, isFetching } = useListAbundanceEngineViews(
    {
      includes: { contents: false, tags: true },
      page: pageState.pageIndex + 1,
      limit: pageState.pageSize,
      sort: sortState?.length ? sortState.map(s => ({ field: s.id, dir: s.desc ? 'desc' : 'asc' })) : [],
      filters: {
        search: debouncedSearchTerm ? [{ op: 'contains', value: debouncedSearchTerm }] : undefined,
        tags: tags.length > 0 ? [{ op: 'in', value: tags.map(t => t.value) }] : undefined
      }
    }
  )

  const handleSortChange = (sortUpdater) => {
    setSortState(sortUpdater)
    setPageState((prev) => ({ ...prev, pageIndex: 0 }))
  }
  const handlePageChange = (pageUpdater) => {
    setPageState(pageUpdater)
  }

  return (
    <div className='p-4 flex flex-col gap-2'>
      <div className='flex justify-between items-center flex-wrap gap-2'>
        <div className='flex gap-md flex-wrap'>
          <div style={{ width: '400px', maxWidth: '90%' }}>
            <SydInput
              placeholder='Search views...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              iconName='search'
              size='sm'
              minWidth='300px'
            />
          </div>
          <div style={{ width: '300px' }}>
            <ViewTagsAutocomplete onChange={(tags) => setTags(tags)} />
          </div>
        </div>

        <Link href='/admin/abundance-engine-views/new' className='text-white'>
          <SydButton
            variant='primary'
            icon='add'
            size='sm'
          >
            Add View
          </SydButton>
        </Link>
      </div>
      <OpalGrid
        className='table-border'
        data={data?.rows || []}
        rowCount={data?.count || 0}
        columns={columnConfig.columns}
        isFetching={isLoading || isFetching}
        pageState={pageState}
        sortState={sortState}
        onPageChange={handlePageChange}
        onSortChange={handleSortChange}
      />
    </div>
  )
}

export default AbundanceEngineListView
